import { USER_LOGOUT_SUCCESS } from './ducks/auth';

const apiErrorMiddleware = store => next => (action) => {
  // Checks to see if the action has a payload and if the payload is an ApiError

  if (
    action.payload &&
    (action.payload.name === 'ApiError' || action.payload.name === 'RequestError')
  ) {
    if (action.payload.name === 'RequestError') {
      // Server currently returns no Access-Control headers when hitting a 403,
      // which results in a `fetch` error due to CORS instead of a normal 403 unauthed response.
      // Treat this just as a regular unauthed response until we switch the server handling.
      setTimeout(() => {
        store.dispatch({ type: USER_LOGOUT_SUCCESS });
      }, 100);
    }

    switch (action.payload.status) {
      // Note: we should break these up:
      // 401 should be for expired or unauthenticated sessions
      // 403 should be for lacking proper access rights when properly authenticated.
      case 403:
      case 401:
        // clear out creds and retry
        // TODO: Timeout only there to allow the current dispatch to finish. This is gross but
        // should change to a better handling of unauthenticated attempts anyway.
        setTimeout(() => {
          store.dispatch({ type: USER_LOGOUT_SUCCESS });
        }, 100);
        break;
      case 404:
        // push to 404 page
        break;
      default:
        return next(action);
    }
  }

  return next(action);
};

export default apiErrorMiddleware;



// WEBPACK FOOTER //
// ./src/redux/apiErrorMiddleware.js